import { useEffect, RefObject } from "react";

/**
 * Хук для установки зависимости одного элемента от изменения размеров другого
 * @param refFrom ссылка (useRef) на тот элемент, который может менять размер
 * @param refTo ссылка (useRef) на тот элемент, в котором что-то должно происходить при изменении размера from-элемента
 * @param onResize колбэк, который срабатывает при изменении
 */
export const useResizeDependency = <
  From extends HTMLElement,
  To extends HTMLElement,
>(
  refFrom: RefObject<From>,
  refTo: RefObject<To>,
  onResize: (from: From, to: To) => void,
) => {
  useEffect(() => {
    const body = refFrom.current;
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === body) {
          if (refTo.current) {
            onResize(body, refTo.current);
          }
        }
      });
    });
    if (body) {
      resizeObserver.observe(body);
    }
    return () => {
      resizeObserver.disconnect();
    };
  }, [refFrom.current]);
};
